import React from 'react';
import './EmptyState.css';

const EmptyState: React.FC<{ message: string }> = ({ message }) => (
  <div className="dashboard-empty-state">{message}</div>
);

export default EmptyState;
